import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

window.mount = function(id) {
  let app = document.getElementById(id);
  ReactDOM.render( <App {...(app.dataset)} />, document.getElementById(id) );
}

window.unmount = function(id) {
  let app = document.getElementById(id);
  return ReactDOM.unmountComponentAtNode(app)
} 

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
